import { useState } from 'react';

import { CloudDownload, PictureAsPdf } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { fetchTrancheLetter, fetchTrancheData } from 'api';
import { downloadFile } from 'helpers';
import { useSnackContext } from 'hooks/useSnackContext';

export const SignedTrancheButtons = (props: { trancheId: number }) => {
  const { trancheId } = props;
  const [fetchingPDF, setFetchingPDF] = useState(false);
  const [fetchingCSV, setFetchingCSV] = useState(false);
  const { setSnack } = useSnackContext();
  const handleDownloadPDF = async (tranche_id: number) => {
    try {
      setFetchingPDF(true);
      const { data, headers } = await fetchTrancheLetter(tranche_id);
      downloadFile({ headers: headers, data: data });
    } catch (e) {
      setSnack((props) => ({
        ...props,
        severity: 'error',
        open: true,
        message: 'Failed To Fetch Tranche Letter',
        error: e as Error,
      }));
    }
    setFetchingPDF(false);
  };
  const handleDownloadCSV = async (tranche_id: number) => {
    try {
      setFetchingCSV(true);
      const { data, headers } = await fetchTrancheData(tranche_id);
      downloadFile({ headers: headers, data: data });
    } catch (e) {
      setSnack((props) => ({
        ...props,
        severity: 'error',
        open: true,
        message: 'Failed To Fetch Tranche CSV',
        error: e as Error,
      }));
      setFetchingCSV(false);
    }
    setFetchingCSV(false);
  };

  return (
    <Box sx={{ display: 'flex', flexFlow: 'row' }}>
      <LoadingButton
        sx={{ mr: 1 }}
        loading={fetchingPDF}
        onClick={() => handleDownloadPDF(trancheId)}
        startIcon={<PictureAsPdf fontSize='small' />}
      >
        Letter
      </LoadingButton>
      <LoadingButton
        loading={fetchingCSV}
        onClick={() => handleDownloadCSV(trancheId)}
        startIcon={<CloudDownload fontSize='small' />}
      >
        CSV
      </LoadingButton>
    </Box>
  );
};
